/**
 * @generated SignedSource<<3345245757c44c2356fbd74be9f7c85c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PricingVersion = "VERSION_1" | "VERSION_2";
export type ProductProvider = "CASA_DE_LAS_CARCASAS" | "CUSTOM_CAT" | "FAVORITE_GIFT" | "HP" | "INVITION" | "PRINTFUL" | "PRINTFUL_DIRECT" | "UNDEFINED" | "VERSORI" | "ZAKEKE";
export type providerSelectionQuery$variables = {
  salesChannelID: string;
};
export type providerSelectionQuery$data = {
  readonly hasCustomCatKey: boolean;
  readonly hasInvitionKey: boolean;
  readonly hasPrintfulKey: boolean;
  readonly subscription: {
    readonly id: string;
    readonly maxProducts: {
      readonly canAddProduct: boolean;
      readonly maxProducts: number | null;
      readonly numProducts: number | null;
      readonly numPublishedProducts: number | null;
      readonly pricingVersion: PricingVersion;
    };
  } | null;
  readonly supportedProviders: ReadonlyArray<ProductProvider>;
};
export type providerSelectionQuery = {
  response: providerSelectionQuery$data;
  variables: providerSelectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "salesChannelID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "salesChannelID",
        "variableName": "salesChannelID"
      }
    ],
    "kind": "ScalarField",
    "name": "supportedProviders",
    "storageKey": null
  },
  {
    "alias": "hasPrintfulKey",
    "args": [
      {
        "kind": "Literal",
        "name": "provider",
        "value": "PRINTFUL"
      }
    ],
    "kind": "ScalarField",
    "name": "hasValidProviderKey",
    "storageKey": "hasValidProviderKey(provider:\"PRINTFUL\")"
  },
  {
    "alias": "hasInvitionKey",
    "args": [
      {
        "kind": "Literal",
        "name": "provider",
        "value": "INVITION"
      }
    ],
    "kind": "ScalarField",
    "name": "hasValidProviderKey",
    "storageKey": "hasValidProviderKey(provider:\"INVITION\")"
  },
  {
    "alias": "hasCustomCatKey",
    "args": [
      {
        "kind": "Literal",
        "name": "provider",
        "value": "CUSTOM_CAT"
      }
    ],
    "kind": "ScalarField",
    "name": "hasValidProviderKey",
    "storageKey": "hasValidProviderKey(provider:\"CUSTOM_CAT\")"
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ZakekeSubscription",
    "kind": "LinkedField",
    "name": "subscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MaxProducts",
        "kind": "LinkedField",
        "name": "maxProducts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pricingVersion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canAddProduct",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxProducts",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numProducts",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numPublishedProducts",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "providerSelectionQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "providerSelectionQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "e3372b30bc7f31a5b2459ff224ea1703",
    "id": null,
    "metadata": {},
    "name": "providerSelectionQuery",
    "operationKind": "query",
    "text": "query providerSelectionQuery(\n  $salesChannelID: ID!\n) {\n  supportedProviders(salesChannelID: $salesChannelID)\n  hasPrintfulKey: hasValidProviderKey(provider: PRINTFUL)\n  hasInvitionKey: hasValidProviderKey(provider: INVITION)\n  hasCustomCatKey: hasValidProviderKey(provider: CUSTOM_CAT)\n  subscription {\n    id\n    maxProducts {\n      pricingVersion\n      canAddProduct\n      maxProducts\n      numProducts\n      numPublishedProducts\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "909ead5579ed519024c98d0d8b831872";

export default node;
